var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandPlotBlock1044(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M540.762 553.74L546.136 533.809L525.524 533.537L519.946 553.536L540.762 553.74Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandPlotBlock1044);
export default __webpack_public_path__ + "static/media/land_plot_block_1044.8a947cb63f245e7d616fd43fc3a57839.svg";
export { ForwardRef as ReactComponent };